
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-penilik/pejabat-penilai-kinerja",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-penilik/pejabat-penilai-kinerja/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-penilik/pejabat-penilai-kinerja"])
      });
    }
  